import React from "react";

import { BaseQuestionForm } from "./BaseQuestionForm";
import { RequiredQuestionForm } from "./RequiredQuestionForm";
import { Question } from "survey";

interface QuestionFormProps {
  question: Question;
  children: React.ReactNode;
}
export const QuestionForm = ({ children, question }: QuestionFormProps) => {
  return (
    <>
      <BaseQuestionForm question={question} />
      {children}
      <RequiredQuestionForm question={question} />
    </>
  );
};
